import React, { FC } from 'react';

import { graphql } from 'gatsby';
import { Box, Heading, Text } from '@lucid/components-react';
import { Drupal_ParagraphFlexiBoardMembers } from 'generated/drupal-graphql';
import { mqMin, LucidTheme } from '@lucid/theme';

import FlourishedHeading from 'components/flourished-heading/flourished-heading';

interface FlexiBoardMembersProps {
  entity: Drupal_ParagraphFlexiBoardMembers;
}

const FlexiBoardMembers: FC<FlexiBoardMembersProps> = ({ entity: { fieldBoardMembers, fieldHeader } }) => {
  return (
    <Box
      css={(theme: LucidTheme) => ({
        label: 'flexiBoardMembers',
        width: '100%',
        marginTop: theme.space[5],
        marginBottom: theme.space[10],
      })}
      gridColumn="1 / -1"
      px={{ default: 0, tablet: 6 }}
    >
      {fieldHeader && (
        <FlourishedHeading
          as="h2"
          css={(theme: LucidTheme) => ({
            marginBottom: theme.space[7],
            [mqMin.tabletLandscape]: {
              flex: '0 1 45%',
              maxWidth: '45%',
            },
          })}
          variant="headline3XL"
        >
          {fieldHeader}
        </FlourishedHeading>
      )}
      <Box
        css={(theme: LucidTheme) => ({
          label: 'content',
          display: 'grid',
          gridTemplateColumns: 'repeat(1, 1fr)',
          paddingLeft: theme.space[6],
          [mqMin.tabletLandscape]: {
            flexDirection: 'row',
            gridTemplateColumns: 'repeat(3, 1fr)',
            paddingLeft: theme.space[0],
          },
        })}
        gridColumn="1 / -1"
      >
        {fieldBoardMembers &&
          fieldBoardMembers.map(
            ({ entity: { fieldFlexiLeadershipName, fieldFlexiLeadershipRole, fieldFlexiLeadershipCompany } }: any) => (
              <Box
                key={fieldFlexiLeadershipName}
                css={(theme: LucidTheme) => ({
                  gridColumn: '1',
                  marginBottom: theme.space[4],
                  [mqMin.tabletLandscape]: {
                    gridColumn: 'auto',
                  },
                })}
              >
                <Heading
                  as="h2"
                  css={(theme: LucidTheme) => ({
                    color: theme.colors.primary,
                  })}
                  variant="headlineL"
                >
                  {fieldFlexiLeadershipName}
                </Heading>
                <Text variant="paragraphM300">{fieldFlexiLeadershipRole}</Text>
                <Text variant="headlineM">{fieldFlexiLeadershipCompany}</Text>
              </Box>
            ),
          )}
      </Box>
    </Box>
  );
};

export default FlexiBoardMembers;

export const query = graphql`
  fragment flexiBoardMembers on Drupal_ParagraphFlexiBoardMembers {
    fieldHeader
    fieldBoardMembers {
      entity {
        ... on Drupal_ParagraphFlexiBoardMemberIndividual {
          fieldFlexiLeadershipCompany
          fieldFlexiLeadershipRole
          fieldFlexiLeadershipName
        }
      }
    }
  }
`;
